export default __webpack_public_path__ + "images/M3.27b6cba.png";